import formatDate from './formatDate';

export default function dateRange(chipsDateValue) {
	const today = new Date();
	let startDate;

	switch (chipsDateValue) {
		case 'today':
			startDate = new Date(today);
			startDate.setDate(today.getDate() - 1);
			break;

		case 'month':
			startDate = new Date(today);
			startDate.setMonth(today.getMonth() - 1);
			break;

		default:
			startDate = new Date(today);
			startDate.setDate(today.getDate() - 7);
	}

	return `${formatDate(startDate)}..${formatDate(today)}`;
}
